import { C } from '../../lib/theme';
import { styles } from '../../lib/styles';
import { $ } from '../../lib/util';
import { Dialog } from '../Dialog';
import { useUIState } from '../../state/contexts/UIStateContext';
import { useDisputeActions } from '../../state/actions/disputes';

export function ShaftResponseModal() {
  const { setModal, setModalData, modalData } = useUIState();
  const { respondShaftDispute } = useDisputeActions();
  return (
    <Dialog title={`Log Registrant ${modalData.responseType === 'MODIFICATION' ? 'Modification' : 'Objection'}`} onClose={() => setModal(null)}>
        <div style={{ fontSize: 13, color: C.textMuted, marginBottom: 16 }}>
          {modalData.responseType === 'MODIFICATION'
            ? 'Registrant is submitting modified content to replace the flagged SHAFT content. This will be forwarded to the Vetting Agent for review.'
            : 'Registrant is contesting the SHAFT determination. BCID LLC will have 30 calendar days to review and issue a final, non-appealable determination.'}
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="shaft-response-text" style={{ fontSize: 11, color: C.textMuted }}>
            {modalData.responseType === 'MODIFICATION' ? 'Modified Content / Replacement Details' : 'Objection Reasoning'}
          </label>
          <textarea id="shaft-response-text" style={styles.textarea} placeholder={modalData.responseType === 'MODIFICATION' ? 'Describe the modified Call Logo, Call Reason, or Display Name...' : 'Describe the basis for the objection...'} />
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button style={{ ...styles.btn, ...styles.btnGold }} onClick={() => {
            const text = $('shaft-response-text').value;
            if (text) { respondShaftDispute(modalData.caseId, modalData.disputeId, modalData.responseType, text); setModal(null); setModalData({}); }
          }}>Submit {modalData.responseType === 'MODIFICATION' ? 'Modification' : 'Objection'}</button>
          <button style={{ ...styles.btn, ...styles.btnOutline }} onClick={() => { setModal(null); setModalData({}); }}>Cancel</button>
        </div>
    </Dialog>
  );
}
